import { DBColumnNames, ProductNames } from '../models/website-models';

export const LicensePlanPricing: {
  [key: string]: {
    month: { [key: string]: any }[];
    year: { [key: string]: any }[];
  };
} = {
  licenses: {
    month: [
      {
        name: 'Agent Seats Licenses',
        dbColumnName: DBColumnNames.AGENT_SEATS_LICENSES,
        trial: { value: '1', stripeProdName: ProductNames.EMPTY },
        startUp: { value: '5', stripeProdName: ProductNames.EMPTY },
        growth: { value: '15', stripeProdName: ProductNames.EMPTY },
        scale: { value: '50', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Admin Licenses',
        dbColumnName: DBColumnNames.ADMIN_LICENSES,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: '1', stripeProdName: ProductNames.EMPTY },
        growth: { value: '2', stripeProdName: ProductNames.EMPTY },
        scale: { value: '3', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Supervisor Licenses',
        dbColumnName: DBColumnNames.SUPERVISOR_LICENSES,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'no', stripeProdName: ProductNames.EMPTY },
        growth: { value: '2', stripeProdName: ProductNames.EMPTY },
        scale: { value: '5', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Endpoint Licenses',
        dbColumnName: DBColumnNames.END_POINT_LICENSES,
        trial: { value: '1', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/per',
          stripeProdName: ProductNames.Endpoint_Lic_Startup,
        },
        growth: {
          value: '+$price/per',
          stripeProdName: ProductNames.Endpoint_Lic_Growth,
        },
        scale: { value: '50 EP Included', stripeProdName: ProductNames.EMPTY },
      },
    ],
    year: [
      {
        name: 'Agent Seats Licenses',
        dbColumnName: DBColumnNames.AGENT_SEATS_LICENSES,
        trial: { value: '1', stripeProdName: ProductNames.EMPTY },
        startUp: { value: '5', stripeProdName: ProductNames.EMPTY },
        growth: { value: '15', stripeProdName: ProductNames.EMPTY },
        scale: { value: '50', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Admin Licenses',
        dbColumnName: DBColumnNames.ADMIN_LICENSES,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: '1', stripeProdName: ProductNames.EMPTY },
        growth: { value: '2', stripeProdName: ProductNames.EMPTY },
        scale: { value: '3', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Supervisor Licenses',
        dbColumnName: DBColumnNames.SUPERVISOR_LICENSES,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'no', stripeProdName: ProductNames.EMPTY },
        growth: { value: '2', stripeProdName: ProductNames.EMPTY },
        scale: { value: '5', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Endpoint Licenses',
        dbColumnName: DBColumnNames.END_POINT_LICENSES,
        trial: { value: '1', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/per',
          stripeProdName: ProductNames.Endpoint_Lic_Startup,
        },
        growth: {
          value: '+$price/per',
          stripeProdName: ProductNames.Endpoint_Lic_Growth,
        },
        scale: { value: '50 EP Included', stripeProdName: ProductNames.EMPTY },
      },
    ],
  },
  features: {
    month: [
      {
        name: 'Basic Call Handling',
        dbColumnName: DBColumnNames.BASIC_CALL_HANDLING,
        trial: { value: 'Basic', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: {
          value: 'yes',
          stripeProdName: ProductNames.EMPTY as ProductNames,
        },
      },
      {
        name: 'Advanced Call Routing',
        dbColumnName: DBColumnNames.ADVANCED_CALL_ROUTING,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'IVR',
        dbColumnName: DBColumnNames.IVR,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Local Presence Dialing',
        dbColumnName: DBColumnNames.LOCAL_PRESENCE_DIALING,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Predictive Dialer',
        dbColumnName: DBColumnNames.PREDICTIVE_DIALER,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/m',
          stripeProdName: ProductNames.Predictive_Dialer_Startup,
        },
        growth: {
          value: '+$price/m',
          stripeProdName: ProductNames.Predictive_Dialer_Growth,
        },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Advanced Omnichannel',
        dbColumnName: DBColumnNames.ADVANCED_OMNI_CHANNEL,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/channel/m',
          stripeProdName: ProductNames.Advanced_Omnichannel_Startup,
        },
        growth: { value: 'Email/SMS/Chat', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'All Channels', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Ticketing Integration',
        dbColumnName: DBColumnNames.TICKETING_SYSTEM,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'add-on', stripeProdName: ProductNames.EMPTY },
        growth: {
          value: 'Basic Integration',
          stripeProdName: ProductNames.EMPTY,
        },
        scale: {
          value: 'Advanced Integration',
          stripeProdName: ProductNames.EMPTY,
        },
      },
      {
        name: 'Voice-to-Case',
        dbColumnName: DBColumnNames.VOICE_TO_CASE,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'no', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'no', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Case Mangement',
        dbColumnName: DBColumnNames.CASE_MANAGEMETN,
        trial: { value: 'Basic', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'Basic', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Call Disposition Notes',
        dbColumnName: DBColumnNames.CALL_DISPOSITION_NOTES,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Business Hours Config',
        dbColumnName: DBColumnNames.BUSINESS_HOURS_CONFIG,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Voicemail Management',
        dbColumnName: DBColumnNames.VOICEMAIL_MANAGEMENT,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'iKunnect Intelligence',
        dbColumnName: DBColumnNames.IKUNNECT_INTELLIGENCE,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/m',
          stripeProdName: ProductNames.Adv_iKunnect_Intelligence_Startup,
        },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Number Management',
        dbColumnName: DBColumnNames.NUMBER_MANAGEMENT,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Advanced AI Automation',
        dbColumnName: DBColumnNames.ADVANCED_AI_AUTOMATION,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'no', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'no', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Client Branding',
        dbColumnName: DBColumnNames.CLIENT_BRANDING,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
    ],
    year: [
      {
        name: 'Basic Call Handling',
        dbColumnName: DBColumnNames.BASIC_CALL_HANDLING,
        trial: { value: 'Basic', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Advanced Call Routing',
        dbColumnName: DBColumnNames.ADVANCED_CALL_ROUTING,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'IVR',
        dbColumnName: DBColumnNames.IVR,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Local Presence Dialing',
        dbColumnName: DBColumnNames.LOCAL_PRESENCE_DIALING,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Predictive Dialer',
        dbColumnName: DBColumnNames.PREDICTIVE_DIALER,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/y',
          stripeProdName: ProductNames.Predictive_Dialer_Startup,
        },
        growth: {
          value: '+$price/y',
          stripeProdName: ProductNames.Predictive_Dialer_Growth,
        },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Advanced Omnichannel',
        dbColumnName: DBColumnNames.ADVANCED_OMNI_CHANNEL,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/channel/y',
          stripeProdName: ProductNames.Advanced_Omnichannel_Startup,
        },
        growth: { value: 'Email/SMS/Chat', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'All Channels', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Ticketing Integration',
        dbColumnName: DBColumnNames.TICKETING_SYSTEM,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'add-on', stripeProdName: ProductNames.EMPTY },
        growth: {
          value: 'Basic Integration',
          stripeProdName: ProductNames.EMPTY,
        },
        scale: {
          value: 'Advanced Integration',
          stripeProdName: ProductNames.EMPTY,
        },
      },
      {
        name: 'Voice-to-Case',
        dbColumnName: DBColumnNames.VOICE_TO_CASE,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'no', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'no', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Case Mangement',
        dbColumnName: DBColumnNames.CASE_MANAGEMETN,
        trial: { value: 'Basic', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'Basic', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Call Disposition Notes',
        dbColumnName: DBColumnNames.CALL_DISPOSITION_NOTES,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Business Hours Config',
        dbColumnName: DBColumnNames.BUSINESS_HOURS_CONFIG,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Voicemail Management',
        dbColumnName: DBColumnNames.VOICEMAIL_MANAGEMENT,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'iKunnect Intelligence',
        dbColumnName: DBColumnNames.IKUNNECT_INTELLIGENCE,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: {
          value: '+$price/y',
          stripeProdName: ProductNames.Adv_iKunnect_Intelligence_Startup,
        },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Number Management',
        dbColumnName: DBColumnNames.NUMBER_MANAGEMENT,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Advanced AI Automation',
        dbColumnName: DBColumnNames.ADVANCED_AI_AUTOMATION,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'no', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'no', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
      {
        name: 'Client Branding',
        dbColumnName: DBColumnNames.CLIENT_BRANDING,
        trial: { value: 'no', stripeProdName: ProductNames.EMPTY },
        startUp: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        growth: { value: 'yes', stripeProdName: ProductNames.EMPTY },
        scale: { value: 'yes', stripeProdName: ProductNames.EMPTY },
      },
    ],
  },
};

export const PricesByDuration: {
  month: { [key: string]: { value: number; disValue: string } };
  year: { [key: string]: { value: number; disValue: string } };
} = {
  month: {
    trial: { value: 0, disValue: '$-' },
    startUp: { value: 500, disValue: '$500' },
    growth: { value: 1500, disValue: '$1,500' },
    scale: { value: 5000, disValue: '$5,000' },
  },
  year: {
    trial: { value: 0, disValue: '$-' },
    startUp: { value: 4500, disValue: '$4,500' },
    growth: { value: 13500, disValue: '$13,500' },
    scale: { value: 45000, disValue: '$45,000' },
  },
};
